import React from 'react'
import {
	AlertsBaseDrawer,
	AlertsComparator,
	AlertsComparatorUnit,
	AlertsComparatorValue,
	AlertsComparisonType,
	AlertsConditionName,
	AlertsDrawerBaseFooter,
	AlertsMoreFeatures,
	AlertsProviders,
	AlertsSitesRequired
} from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import { Grid } from "@mui/material"
import { AppFormSection } from "@components"


import { BACKEND_APIS } from "@constants"


export default function PriceChangeDrawer({ onSubmitAlert, isLoading }) {

	return <AlertsBaseDrawer
		footer={<AlertsDrawerBaseFooter onSubmitAlert={onSubmitAlert} isLoading={isLoading} />}
		content={<>
			<AppFormSection icon="tag" title="Condition">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-pch-name">
					<AlertsConditionName/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="globe" title="Sites">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-pch-sites">
					<AlertsSitesRequired/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="car" title="Providers">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-pch-providers">
					<AlertsProviders/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="scale-balanced" title="Comparison">
				<Grid container spacing={2}>
				<Grid item xs={4} data-tour-id="cond-pch-comparator">
					<AlertsComparator
						urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/comparator_changes`}
					/>
				</Grid>
				<Grid item xs={4} data-tour-id="cond-pch-comp-value">
					<AlertsComparatorValue/>
				</Grid>
				<Grid item xs={4} data-tour-id="cond-pch-comp-unit">
					<AlertsComparatorUnit/>
				</Grid>
				<Grid item xs={12} data-tour-id="cond-pch-comp-type">
					<AlertsComparisonType/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="sliders" title="More features" hint="optional">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-pch-more">
					<AlertsMoreFeatures/>
				</Grid>
				</Grid>
			</AppFormSection>
		</>}
	/>
}